import { constantsTypes } from "../reduxConstants";

const initialValue = {};

export const nowShowingMoviesReduce = (state = initialValue, action) => {
  switch (action.type) {
    case constantsTypes.NOW_SHOWING_MOVIE:
      return action.value;
    default:
      return state;
  }
};
